import React, { useEffect, useState } from 'react';
import '../styles/BeforeAfterShowcase.css';

const transformations = [
  { name: 'Andrea', image: '/assets/before-after/Andrea.jpg' },
  { name: 'Client 3', image: '/assets/before-after/Client 3.png' },
  { name: 'Client 1', image: '/assets/before-after/Client.zip - 1.png' },
  { name: 'Transformation 4', image: '/assets/before-after/IMG_20201103_121540.jpg' },
  { name: 'Kashmira', image: '/assets/before-after/Kashmira (1).jpg' },
  { name: 'Linda', image: '/assets/before-after/Linda.jpg' },
  { name: 'Transformation 7', image: '/assets/before-after/Untitled design (1) (1).png' },
  { name: 'Zenobia', image: '/assets/before-after/Zenobia.jpg' },
];

const getSlidesPerView = () => {
  if (typeof window === 'undefined') {
    return 3;
  }

  return window.innerWidth < 768 ? 1 : 3;
};

export function BeforeAfterShowcase() {
  const [slidesPerView, setSlidesPerView] = useState(getSlidesPerView);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setSlidesPerView(getSlidesPerView());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setActiveIndex((currentIndex) => currentIndex % transformations.length);
  }, [slidesPerView]);

  const visibleItems = Array.from({ length: slidesPerView }, (_, offset) => {
    const itemIndex = (activeIndex + offset) % transformations.length;
    return transformations[itemIndex];
  });

  useEffect(() => {
    const interval = window.setInterval(() => {
      setActiveIndex((currentIndex) => (currentIndex + 1) % transformations.length);
    }, 3500);

    return () => window.clearInterval(interval);
  }, []);

  const handlePrevious = () => {
    setActiveIndex((currentIndex) => (
      currentIndex === 0 ? transformations.length - 1 : currentIndex - 1
    ));
  };

  const handleNext = () => {
    setActiveIndex((currentIndex) => (currentIndex + 1) % transformations.length);
  };

  return (
    <section id="before-after" className="before-after-section">
      <div className="before-after-container">
        <div className="before-after-header">
          <p className="before-after-eyebrow">Results That Speak</p>
          <h2 className="before-after-title">Before &amp; After Transformations</h2>
          <p className="before-after-subtitle">
            Real progress from women who stayed consistent, trusted the process, and built strength with Daniella.
          </p>
        </div>

        <div className="before-after-carousel">
          <button
            type="button"
            className="before-after-nav before-after-nav-prev"
            onClick={handlePrevious}
            aria-label="Previous transformations"
          >
            &larr;
          </button>

          <div className="before-after-grid">
            {visibleItems.map((item) => (
              <article key={item.image} className="before-after-card">
                <div className="before-after-image-wrap">
                  <img src={item.image} alt={`${item.name} before and after transformation`} className="before-after-image" />
                </div>
              </article>
            ))}
          </div>

          <button
            type="button"
            className="before-after-nav before-after-nav-next"
            onClick={handleNext}
            aria-label="Next transformations"
          >
            &rarr;
          </button>
        </div>
      </div>
    </section>
  );
}

export default BeforeAfterShowcase;
